<template>
  <div class="container">
    <h1>Contact us</h1>
    <p>
      Our team is happy to answer your questions.
    </p>
    <p>
      Send an email to <a
        href="mailto:api.team@swisscom.com?subject=Support Request from Messaging API Products Dashboard">api.team@swisscom.com</a>
      and we'll be in touch as soon as possible.
    </p>
  </div>
</template>

<style>
a {
  text-decoration: none !important;
}
</style>
